//## Use [xss](https://github.com/leizongmin/js-xss) for xss portection
const { FilterXSS } = require('xss');
const memoize = require('lodash/function/memoize');
const filterer = new FilterXSS({
    whiteList: [],
    stripIgnoreTag: true
});
const filterXSS = memoize(filterer.process.bind(filterer));

const NON_ISO8859_CHARS_REG_EX = /[^\x20-\x7E\xA0-\xFF]/g;

/**
 * Validate given value for potentially XSS.
 * @param {String} unsafeValue      unsafe consumer value.
 * @returns {String}
 */
const checkPotentiallyXSS = (unsafeValue) => {
    const slicedUnsafeValue = unsafeValue.slice(0);
    const safeValue = filterXSS(slicedUnsafeValue);

    return slicedUnsafeValue !== safeValue;
};

/**
 * Filter all possible XSS attacks given string value.
 * @param {String} unsafeValueConsumer       unsafe consumer value.
 * @returns {String}
 */
const filterPotentiallyXSS = (unsafeValueConsumer) => {
    return filterXSS(unsafeValueConsumer.slice(0));
};

/**
 * Filter all chars not in ISO 8859-1
 * @param {String} unsafeValueConsumer       unsafe consumer value.
 * @returns {String}
 */
const filterNonISO8859Chars = (text) => {
    return text.replace(NON_ISO8859_CHARS_REG_EX, '');
};

module.exports = {
    checkPotentiallyXSS,
    filterPotentiallyXSS,
    filterNonISO8859Chars
};
